if (!customElements.get('accordion-content')) {
  customElements.define(
    'accordion-content',
    class Accordion extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const summary = e.target.closest('summary');
          if (!summary || !this.contains(summary)) return;

          e.preventDefault();

          const details = summary.closest('details');
          const isOpen = details.classList.contains('is-open');

          // ✅ FIX: Null out callbacks BEFORE cancel so they don't wipe the frozen height
          const cancelAnim = (el) => {
            if (!el._anim) return;
            el._anim.onfinish = null;
            el._anim.oncancel = null;
            const h = el.getBoundingClientRect().height;
            el._anim.cancel();
            el.style.height = `${h}px`;
            el._anim = null;
          };

          const resetStyles = (el) => {
            el.style.overflow = '';
            el.style.height = '';
            el._anim = null;
          };

          const animateIcons = (summary, open) => {
            const plus = summary.querySelector('.icon-plus');
            const minus = summary.querySelector('.icon-minus');
            const caret = summary.querySelector('.icon-caret');

            [plus, minus, caret].forEach(el => el?._anim?.cancel());

            if (caret) {
              caret._anim = caret.animate(
                open
                  ? [{ transform: 'translateY(-50%) rotate(0deg)' }, { transform: 'translateY(-50%) rotate(180deg)' }]
                  : [{ transform: 'translateY(-50%) rotate(180deg)' }, { transform: 'translateY(-50%) rotate(0deg)' }],
                { duration: 120, easing: 'ease', fill: 'forwards' }
              );
              return;
            }

            if (!plus || !minus) return;

            if (open) {
              plus._anim = plus.animate(
                [{ opacity: 1, transform: 'translateY(-50%) rotate(0deg)' }, { opacity: 0, transform: 'translateY(-50%) rotate(90deg)' }],
                { duration: 120, easing: 'ease', fill: 'forwards' }
              );
              minus._anim = minus.animate(
                [{ opacity: 0, transform: 'translateY(-50%) scale(0.8)' }, { opacity: 1, transform: 'translateY(-50%) scale(1)' }],
                { duration: 120, easing: 'ease', fill: 'forwards' }
              );
            } else {
              minus._anim = minus.animate(
                [{ opacity: 1, transform: 'translateY(-50%) scale(1)' }, { opacity: 0, transform: 'translateY(-50%) scale(0.8)' }],
                { duration: 120, easing: 'ease', fill: 'forwards' }
              );
              plus._anim = plus.animate(
                [{ opacity: 0, transform: 'translateY(-50%) rotate(90deg)' }, { opacity: 1, transform: 'translateY(-50%) rotate(0deg)' }],
                { duration: 120, easing: 'ease', fill: 'forwards' }
              );
            }
          };

          const closeOthers = () => {
            const siblings = this.closest('[data-accordion-group]')
              ?.querySelectorAll('accordion-content details.is-open');

            siblings?.forEach((sibling) => {
              if (sibling === details) return;

              cancelAnim(sibling); // ✅ uses safe cancel

              const sibSummary = sibling.querySelector('summary');
              const start = sibling.getBoundingClientRect().height;
              const end = sibSummary.offsetHeight;

              sibling.style.overflow = 'hidden';
              animateIcons(sibSummary, false);

              sibling._anim = sibling.animate(
                [{ height: `${start}px` }, { height: `${end}px` }],
                { duration: 180, easing: 'ease' }
              );

              sibling._anim.onfinish = () => {
                sibling.removeAttribute('open');
                sibling.classList.remove('is-open');
                resetStyles(sibling);
              };
              sibling._anim.oncancel = () => resetStyles(sibling);
            });
          };

          if (!isOpen) {
            // OPEN
            cancelAnim(details); // ✅ safe cancel — height is frozen, callbacks won't fire

            closeOthers();

            const startHeight = details.getBoundingClientRect().height;
            details.classList.add('is-open');
            details.setAttribute('open', '');
            const endHeight = details.scrollHeight;

            details.style.overflow = 'hidden';
            details.style.height = `${startHeight}px`;

            animateIcons(summary, true);

            details._anim = details.animate(
              [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
              { duration: 100, easing: 'ease' }
            );

            details._anim.onfinish = () => resetStyles(details);
            details._anim.oncancel = () => resetStyles(details);

          } else {
            // CLOSE
            cancelAnim(details); // ✅ safe cancel

            const startHeight = details.getBoundingClientRect().height;
            const endHeight = summary.offsetHeight;

            details.style.overflow = 'hidden';
            details.style.height = `${startHeight}px`;

            animateIcons(summary, false);

            details._anim = details.animate(
              [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
              { duration: 100, easing: 'ease' }
            );

            details._anim.onfinish = () => {
              details.removeAttribute('open');
              details.classList.remove('is-open');
              resetStyles(details);
            };
            details._anim.oncancel = () => {
              details.setAttribute('open', '');
              resetStyles(details);
            };
          }
        });
      }
    }
  );
}